import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  /** Init Service */
  initChatService: `${NAMESPACE}_CHAT_INIT_SERVICE`,
  /** Window actions */
  toggleChatWindow: `${NAMESPACE}_CHAT_TOGGLE_WINDOW`,
  removeChatWindow: `${NAMESPACE}_CHAT_CLOSE_WINDOW`,
  addNewChatWindow: `${NAMESPACE}_CHAT_ADD_NEW_WINDOW`,
  updateChatWindows: `${NAMESPACE}_CHAT_UPDATE_WINDOWS`,
  updateSingleChat: `${NAMESPACE}_CHAT_UPDATE_SINGLE_WINDOW`,
  /** Messages */
  getUnreadMessages: `${NAMESPACE}_CHAT_GET_UNREAD_MESSAGES`,
  receiveMessage: `${NAMESPACE}_CHAT_RECEIVE_MESSAGE`,
  addMessage: `${NAMESPACE}_CHAT_ADD_MESSAGE`,
  updateSingleMessage: `${NAMESPACE}_CHAT_UPDATE_MESSAGE`,
  updateMessages: `${NAMESPACE}_CHAT_UPDATE_MESSAGES`,
  sendMessage: `${NAMESPACE}_CHAT_SEND_MESSAGE`,
  readMessage: `${NAMESPACE}_CHAT_READ_MESSAGE`,
  readTicketMessages: `${NAMESPACE}_CHAT_READ_TICKET_MESSAGES`,
  /** Call */
  receiveACall: `${NAMESPACE}_CHAT_RECEIVE_A_CALL`,
  responseCall: `${NAMESPACE}_CHAT_RESPONSE_CALL`,
  toggleCallStatus: `${NAMESPACE}_CHAT_TOGGLE_CALL_STATUS`
};

export const actionCreators = {
  /** Init Service */
  initChatService: () => ({ type: actions.initChatService }),
  /** Window actions */
  closeChatService: () => ({ type: actions.closeChatService }),
  toggleChatWindow: (payload) => ({ type: actions.toggleChatWindow, payload }),
  removeChatWindow: (payload) => ({ type: actions.removeChatWindow, payload }),
  addNewChatWindow: (payload) => ({ type: actions.addNewChatWindow, payload }),
  updateChatWindows: (payload) => ({ type: actions.updateChatWindows, payload }),
  updateSingleChat: (payload) => ({ type: actions.updateSingleChat, payload }),
  /** Messages */
  getUnreadMessages: (payload) => ({ type: actions.getUnreadMessages, payload }),
  receiveMessage: (payload) => ({ type: actions.receiveMessage, payload }),
  addMessage: (payload) => ({ type: actions.addMessage, payload }),
  updateSingleMessage: (payload) => ({ type: actions.updateSingleMessage, payload }),
  updateMessages: (payload) => ({ type: actions.updateMessages, payload }),
  sendMessage: (payload) => ({ type: actions.sendMessage, payload }),
  readMessage: (payload) => ({ type: actions.readMessage, payload }),
  readTicketMessages: (payload) => ({ type: actions.readTicketMessages, payload }),
  /** Call */
  receiveACall: (payload) => ({ type: actions.receiveACall, payload }),
  responseCall: (payload) => ({ type: actions.responseCall, payload }),
  toggleCallStatus: (payload) => ({ type: actions.toggleCallStatus, payload })
};

export default {
  actions,
  actionCreators
};
